import { render, staticRenderFns } from "./Page-GeneralCourse.vue?vue&type=template&id=d0f90dca&"
import script from "./Page-GeneralCourse.vue?vue&type=script&lang=js&"
export * from "./Page-GeneralCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports